"use client";

import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import useTheme from "src/context/appThemeContext";

const FAQSection = ({ faqs = [] }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const { theme, mounted } = useTheme();
  const isDark = mounted && theme === "dark";

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section relative overflow-hidden  text-text-primary mb-10!   ">
      <style
        dangerouslySetInnerHTML={{
          __html: `
        @keyframes floatSlow {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-8px) rotate(1deg); }
        }
        @keyframes floatFast {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-6px) rotate(-1.5deg); }
        }
        .animate-float-slow {
          animation: floatSlow 6s ease-in-out infinite;
        }
        .animate-float-fast {
          animation: floatFast 4.5s ease-in-out infinite;
        }

        /* 1920px wide viewport (Large Desktops / Full HD) */
        @media (min-width: 1920px) {
          .faq-container {
            max-width: 1540px !important;
          }
          .faq-grid {
            gap: 3.5rem !important;
          }
          .faq-left-card {
            padding: 3.5rem !important;
            border-radius: 2rem !important;
          }
          .faq-right-card {
            padding: 2.5rem !important;
            border-radius: 2rem !important;
          }
          .faq-badge {
            font-size: 1rem !important;
          }
          .faq-heading {
            font-size: 52px !important;
            margin-top: 1.5rem !important;
          }
          .faq-desc {
            font-size: 18px !important;
            max-width: 480px !important;
            margin-top: 1.5rem !important;
          }
          .faq-bubbles-container {
            height: 180px !important;
            margin-top: 4rem !important;
          }
          .faq-bubbles-inner {
            width: 280px !important;
          }
          .faq-bubble-purple {
            width: 150px !important;
            height: 150px !important;
          }
          .faq-bubble-blue {
            width: 115px !important;
            height: 115px !important;
          }
          .faq-accordion-item {
            border-radius: 1.25rem !important;
          }
          .faq-toggle-btn {
            padding: 1.25rem 1.5rem !important;
          }
          .faq-number-box {
            width: 3.5rem !important;
            height: 3.5rem !important;
            font-size: 1rem !important;
            border-radius: 0.875rem !important;
          }
          .faq-question {
            font-size: 1.125rem !important;
          }
          .faq-chevron-box {
            width: 2.75rem !important;
            height: 2.75rem !important;
            border-radius: 0.875rem !important;
          }
          .faq-chevron-box svg {
            width: 0.875rem !important;
            height: 0.875rem !important;
          }
          .faq-answer-panel {
            padding-left: 80px !important;
            padding-right: 2rem !important;
          }
          .faq-answer-text {
            font-size: 1rem !important;
          }
        }

        /* 2560px wide viewport (2K / QHD monitors) */
        @media (min-width: 2560px) {
          .faq-container {
            max-width: 2000px !important;
          }
          .faq-grid {
            gap: 4.5rem !important;
          }
          .faq-left-card {
            padding: 4.5rem !important;
            border-radius: 2.5rem !important;
          }
          .faq-right-card {
            padding: 3.5rem !important;
            border-radius: 2.5rem !important;
          }
          .faq-badge {
            font-size: 1.25rem !important;
          }
          .faq-heading {
            font-size: 68px !important;
            margin-top: 2rem !important;
          }
          .faq-desc {
            font-size: 22px !important;
            max-width: 580px !important;
            margin-top: 2rem !important;
          }
          .faq-bubbles-container {
            height: 160px !important;
            margin-top: 2rem !important;
          }
          .faq-bubbles-inner {
            width: 360px !important;
          }
          .faq-bubble-purple {
            width: 190px !important;
            height: 190px !important;
          }
          .faq-bubble-blue {
            width: 145px !important;
            height: 145px !important;
          }
          .faq-accordion-item {
            border-radius: 1.75rem !important;
            margin-bottom: 1.25rem !important;
          }
          .faq-toggle-btn {
            padding: 1.75rem 2rem !important;
          }
          .faq-number-box {
            width: 4.5rem !important;
            height: 4.5rem !important;
            font-size: 1.25rem !important;
            border-radius: 1.125rem !important;
          }
          .faq-question {
            font-size: 1.35rem !important;
          }
          .faq-chevron-box {
            width: 3.5rem !important;
            height: 3.5rem !important;
            border-radius: 1.125rem !important;
          }
          .faq-chevron-box svg {
            width: 1.125rem !important;
            height: 1.125rem !important;
          }
          .faq-answer-panel {
            padding-left: 104px !important;
            padding-right: 3rem !important;
          }
          .faq-answer-text {
            font-size: 1.15rem !important;
          }
        }

        /* 3840px wide viewport (4K monitors) */
        @media (min-width: 3840px) {
          .faq-container {
            max-width: 3000px !important;
          }
          .faq-grid {
            gap: 6.5rem !important;
          }
          .faq-left-card {
            padding: 6.5rem !important;
            border-radius: 3.5rem !important;
          }
          .faq-right-card {
            padding: 5.5rem !important;
            border-radius: 3.5rem !important;
          }
          .faq-badge {
            font-size: 1.75rem !important;
          }
          .faq-heading {
            font-size: 96px !important;
            margin-top: 3rem !important;
          }
          .faq-desc {
            font-size: 32px !important;
            max-width: 800px !important;
            margin-top: 3rem !important;
          }
          .faq-bubbles-container {
            height: 360px !important;
            margin-top: 7rem !important;
          }
          .faq-bubbles-inner {
            width: 540px !important;
          }
          .faq-bubble-purple {
            width: 280px !important;
            height: 280px !important;
            bottom: 2rem !important;
          }
          .faq-bubble-blue {
            width: 210px !important;
            height: 210px !important;
          }
          .faq-accordion-item {
            border-radius: 2.5rem !important;
            margin-bottom: 2rem !important;
          }
          .faq-toggle-btn {
            padding: 2.5rem !important;
            gap: 2rem !important;
          }
          .faq-toggle-left {
            gap: 2rem !important;
          }
          .faq-number-box {
            width: 6.5rem !important;
            height: 6.5rem !important;
            font-size: 2rem !important;
            border-radius: 1.5rem !important;
          }
          .faq-question {
            font-size: 2rem !important;
          }
          .faq-chevron-box {
            width: 5.5rem !important;
            height: 5.5rem !important;
            border-radius: 1.5rem !important;
          }
          .faq-chevron-box svg {
            width: 1.75rem !important;
            height: 1.75rem !important;
          }
          .faq-answer-panel {
            padding-left: 144px !important;
            padding-right: 4rem !important;
            padding-top: 2rem !important;
            padding-bottom: 2.5rem !important;
          }
          .faq-answer-text {
            font-size: 1.75rem !important;
          }
        }
      `,
        }}
      />

      <div className=" px-6! md:px-12! relative z-10 mx-auto ">
        <div className="faq-grid grid items-start !gap-8 lg:gap-12 lg:grid-cols-[1fr_1.25fr]">
          <div
            className={`faq-left-card relative overflow-hidden flex flex-col sm:flex-row justify-between rounded-2xl border !p-6 sm:p-10 lg:p-12 backdrop-blur-xl border-border-primary `}
            style={{
              background: "var(--card-background)",
              boxShadow: "var(--card-shadow)",
            }}
          >
            <div className={`absolute -bottom-12 -left-12 w-48 h-48 rounded-full blur-[60px] pointer-events-none ${isDark ? "bg-fuchsia-500/10" : "bg-fuchsia-500/5"}`} />
            <div className={`absolute -bottom-12 -right-12 w-48 h-48 rounded-full blur-[60px] pointer-events-none ${isDark ? "bg-cyan-500/10" : "bg-cyan-500/5"}`} />

            <div className="relative z-10">
              <div className="faq-badge text-xs sm:text-sm font-semibold tracking-widest text-fuchsia-500 uppercase">FAQ</div>

              <h2 className="faq-heading !mt-4 text-3xl sm:text-4xl lg:text-[44px] font-bold leading-[1.15] tracking-tight text-text-primary">
                Answers to your
                <br />
                <span className="bg-gradient-to-r from-fuchsia-500 via-purple-500 to-cyan-400 bg-clip-text text-transparent">burning questions</span>
              </h2>

              <p className="faq-desc !mt-4 text-sm sm:text-base leading-relaxed text-text-secondary max-w-sm">
                Everything you need to know about our services, process, pricing, and support.
              </p>
            </div>

            <div className="faq-bubbles-container relative z-10 h-36 !mt-8 sm:mt-12 md:mt-16 overflow-visible flex justify-center sm:justify-start">
              <div className="faq-bubbles-inner relative w-[280px] h-full">
                <div className="faq-bubble-purple absolute left-0 -bottom-20 animate-float-slow origin-bottom-left">
                  <img src="/images/FAQ/faq.png" alt="FAQ Icon Purple" width={120} height={20} className="object-contain w-full h-full" />
                </div>
              </div>
            </div>
          </div>

          <div
            className={`faq-right-card relative rounded-2xl border !p-5 sm:p-8 backdrop-blur-xl flex flex-col justify-center border-border-primary `}
            style={{
              background: "var(--card-background)",
              boxShadow: "var(--card-shadow)",
            }}
          >
            <div className="flex flex-col !gap-4">
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;

                return (
                  <motion.div
                    layout
                    key={index}
                    transition={{ duration: 0.4, type: "spring", bounce: 0.05 }}
                    className={`faq-accordion-item group relative overflow-hidden rounded-2xl border transition-all duration-300 ${
                      isOpen
                        ? isDark
                          ? "border-purple-500/25 bg-background-primary shadow-[0_0_20px_rgba(168,85,247,0.08)]"
                          : "border-purple-500/25 bg-surface-primary shadow-[0_0_20px_rgba(168,85,247,0.08)]"
                        : isDark
                          ? "border-white/[0.06] bg-[#090b1e]/40 hover:border-white/[0.12] hover:bg-white/[0.02]"
                          : "border-border-primary/40 bg-surface-primary hover:border-border-primary/80 hover:bg-background-secondary/80"
                    }`}
                  >
                    <button onClick={() => toggleFAQ(index)} className="faq-toggle-btn flex w-full items-center justify-between !gap-4 !p-4 text-left group">
                      <div className="faq-toggle-left flex items-center !gap-3 sm:gap-4">
                        <div
                          className={`faq-number-box flex h-10 w-10 sm:h-12 sm:w-12 shrink-0 items-center justify-center rounded-2xl border text-xs sm:text-sm font-extrabold transition-all duration-300 ${
                            isOpen
                              ? isDark
                                ? "border-purple-500/60 bg-purple-500/15 text-purple-300 shadow-[0_0_15px_rgba(168,85,247,0.25)]"
                                : "border-purple-500/60 bg-purple-500/15 text-purple-600 shadow-[0_0_15px_rgba(168,85,247,0.25)]"
                              : isDark
                                ? "border-purple-500/20 bg-purple-500/5 text-purple-400 group-hover:border-purple-500/40 group-hover:text-purple-300"
                                : "border-purple-500/20 bg-purple-500/5 text-purple-500 group-hover:border-purple-500/40 group-hover:text-purple-600"
                          }`}
                        >
                          {String(index + 1).padStart(2, "0")}
                        </div>

                        <h3
                          className={`faq-question text-sm sm:text-base font-medium transition-colors duration-300 ${
                            isOpen ? "text-text-primary" : "text-text-primary/90 group-hover:text-text-primary"
                          }`}
                        >
                          {faq.q}
                        </h3>
                      </div>

                      <div
                        className={`faq-chevron-box flex h-8 w-8 sm:h-10 sm:w-10 shrink-0 items-center justify-center rounded-md border transition-all duration-300 ${
                          isOpen
                            ? isDark
                              ? "border-purple-500/50 bg-purple-500/10 text-purple-300"
                              : "border-purple-500/50 bg-purple-500/10 text-purple-600"
                            : isDark
                              ? "border-white/10 bg-white/5 text-text-secondary group-hover:border-white/20 group-hover:text-text-primary"
                              : "border-border-primary/40 bg-background-primary text-text-secondary group-hover:border-border-primary group-hover:text-text-primary"
                        }`}
                      >
                        <svg
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className={`w-3 h-3 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                        >
                          <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </div>
                    </button>

                    <AnimatePresence initial={false}>
                      {isOpen && (
                        <motion.div
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.35, ease: [0.25, 1, 0.5, 1] }}
                          className="overflow-hidden"
                        >
                          <div className={`!mx-4 h-px ${isDark ? "bg-white/[0.06]" : "bg-border-primary/20"}`} />

                          <div className="faq-answer-panel !p-4 sm:p-5 !pt-3 sm:pt-4 pl-[52px] sm:pl-16 !pr-4 sm:pr-8">
                            <p className="faq-answer-text text-xs sm:text-[14px] leading-relaxed text-text-secondary">{faq.a}</p>
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
